import React, { useState } from 'react';

export default ({OrganizerList, handleShowForm, handleSearch}) => {
  const [search, setSearch] = useState('');
  const handleOnChange = ({target}) => {
    setSearch(target.value)
  }
  return (
    <div className="container daftar-ca" style={{padding:'50px 0px'}}>
      <p className="text-center" style={{fontSize: '20px', marginBottom: '50px'}}>Status Pengakuan<br />Penyelenggara Sertifikasi Elektronik</p>
      <div className="row mx-0">
        <div className="col-lg-10 col-sm-12">
          <input className="form-control" type="text" placeholder="Cari" style={{padding: '10px 20px',height: '37px', borderRadius: '5px'}} onChange={handleOnChange}/>
        </div>
        <div className="col-lg-2 col-sm-12">
          <button className="btn btn-blue w-100" onClick={() => handleSearch(search)}>Cari</button>
        </div>
      </div>
      <table className="table w-100" id="my-datatable" style={{fontSize: '13px'}}>
        <thead>
          <tr>
            <td>Nama Perusahaan</td>
            <td style={{width: '18%'}}>No SK Pengakuan</td>
            <td>
              Website</td>
            <td>Jenis PSrE</td>
            <td>
              Status Pengakuan</td>
            <td>Detail</td>
          </tr>
        </thead>
        <tbody>
          {OrganizerList.map(e => {
            return (
              <tr>
                <td>{e.companyName}</td>
                <td>{e.noRef}</td>
                <td><a href={e.website} target="_blank">{e.website}</a></td>
                <td>{e.type}</td>
                <td>{e.status}</td>
                <td className="text-center">
                  <div className="btn btn-blue popup" style={{padding: '5px !important'}} onClick={() => handleShowForm(e)} ><i class="fas fa-eye" style={{fontSize: '11px'}}></i></div> 
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
